import { render } from "./settings.vue?vue&type=template&id=b9814f3e&scoped=true&ts=true"
import script from "./settings.vue?vue&type=script&lang=ts"
export * from "./settings.vue?vue&type=script&lang=ts"

import "./settings.vue?vue&type=style&index=0&id=b9814f3e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9814f3e"]])

export default __exports__